import { client } from '@hotjar/api-base-client';
import type { Customer } from '../common/model/customer';

export async function getCustomer(accountId: number): Promise<Customer> {
  return client<Customer>({ url: `/api/checkout/customers/${accountId}` });
}
